export default class SidebarCart {
    constructor() {
        this.body = document.body;

        this.cartPage = document.querySelector("div.cart-page");
        this.isCartPage = !!this.cartPage;

        this.sidebarBtn = document.querySelector(".header-top__cart-btn");

        this.sidebar = document.querySelector(".cart-sidebar");
        this.sidebarOverlay = document.querySelector(
            ".cart-sidebar__dark-overlay"
        );

        this.events();
    }

    events() {
        if (!this.isCartPage) {
            this.toggleSidebar();
        }
    }

    toggleSidebar() {
        // Open sidebar cart after click mini cart
        if (this.sidebarBtn) {
            this.sidebarBtn.addEventListener("click", (e) => {
                this.sidebar.classList.add("open");
                this.sidebarOverlay.classList.add("active");
                this.body.style.overflow = "hidden";
                this.body.style.height = "100%";
            });
        }

        // Close sidebar cart after overlay or close button
        document.body.addEventListener("click", (e) => {
            if (e.target.classList.contains("jsCartSidebarClose")) {
                this.sidebar.classList.remove("open");
                this.sidebarOverlay.classList.remove("active");
                this.body.style.overflow = "auto";
                this.body.style.height = "auto";
            }
        });
    }
}